import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	ArcDokladdruhId: null as number | null,
	ArcDokladDruhText: null as string | null,
	CenaCelkemSDph: null as number | null,
	CenotvorbandPzn: null as number | null,
	DobropduvodRtf: null as string | null,
	DokladDruh: null as string | null,
	DokladId: null as number | null,
	DokladNr: null as number | null,
	DokladPfx: null as string | null,
	Doklad3Id: null as number | null,
	DuzpDat: null as Date | null,
	EetBkp: null as string | null,
	EetCommunicStatusPzn: null as number | null,
	EetFik: null as string | null,
	EetOkp: null as string | null,
	EetPkpText: null as string | null,
	EetUid: null as string | null,
	FakturaceprofilId: null as number | null,
	IntrDruhOzn: null as number | null,
	IntrDruhOznText: null as string | null,
	KaroserieNr: null as string | null,
	KdokladNr: null as number | null,
	KdokladPfx: null as string | null,
	NoraPzn: null as number | null,
	PlatbaText: null as string | null,
	PnvId: null as number | null,
	PodilMat: null as number | null,
	PodilSlz: null as number | null,
	PovId: null as number | null,
	PrijemceDicNr: null as string | null,
	PrijemceIcoNr: null as string | null,
	PrijemceObec: null as string | null,
	PrijemcePrijmeniFirma: null as string | null,
	PrijemcePscNr: null as string | null,
	PrijemceStat: null as string | null,
	PrijemceUlice: null as string | null,
	ProvozovnaId: null as number | null,
	SlevamatSk: null as number | null,
	SplatnostDat: null as Date | null,
	Spz: null as string | null,
	Terminal: null as string | null,
	TextLong: null as string | null,
	TextLongExklizivni: null as string | null,
	TextRtf: null as string | null,
	UzavreniDat: null as Date | null,
	PartialBillingClosedDate: null as Date | null, //added
	VozidloId: null as number | null,
	VozidloIdText: null as string | null,
	VyrobekvozOzn: null as string | null,
	ZakazkaDruh: null as string | null,
	ZakazkaId: 0 as number,
	ZakazkaNr: null as number | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	ZakaznikSk: null as number | null,
	CanDobropis: null as boolean | null,
	CanPolozkovyDobropis: null as boolean | null,
	CanStorno: null as boolean | null,
	CanVrubopisCastecnyDobropis: null as boolean | null,
	PlatbaPzn: null as number | null,
	UserMessageList: [] as { Title: string, Message: string, Type: number }[],
	AdvanceAmount: null as number | null,
	GSTNr: null as string | null,
	PriceInclGST: null as number | null,
	MobileNo: null as string | null,
	TotalPartCharge: null as number | null,
	TotalLaborCharge: null as number | null,
	IsReverseJobOrder: null as boolean | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		CenotvorbandPzn: [],
		EetCommunicStatusPzn: [],
		NoraPzn: [],
		PlatbaPzn: [],
		SlevamatSk: [],
		VyrobekvozOzn: [],
		ZakazkaDruh: [],
		ZakaznikSk: [],
		FakturaceprofilId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
